import axios, {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { VITE_API_ENDPOINT } from "src/environments";
import useAuthStore from "stores/auth";
import useUserStore from "stores/user";

const FETCHER: AxiosInstance = axios.create({
  baseURL: VITE_API_ENDPOINT,
});
const { getState, setState } = useAuthStore;
const { getState: getStateUser } = useUserStore;

const checkTokenExpire = (token: string) => {
  try {
    const decodeToken = window.atob(token.split(".")[1]);
    const parseToken = JSON.parse(decodeToken);
    return Math.floor(new Date().getTime() / 1000) >= parseToken.exp;
  } catch (error) {
    console.log("isTokenExpired :", error);
  }
  return true;
};

// const updateToken = async (token: string) => {
//   return await refreshToken(token);
// };

const onRequest = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const { accessToken, refreshToken } = getState();
  if (accessToken) {
    const isTokenExpired = checkTokenExpire(accessToken);
    if (isTokenExpired) {
      if (refreshToken) {
        try {
          const result = await axios.post(`${VITE_API_ENDPOINT}/auth/refresh`, {
            refreshToken,
          });
          setState({
            accessToken: result.data.accessToken,
          });
          config.headers.set(
            "Authorization",
            `Bearer ${result.data.accessToken}`
          );
        } catch (error) {
          console.error('Failed to refresh token:', error);
          // Clear tokens on refresh failure
          const { resetToken } = getState();
          const { resetUser } = getStateUser();
          resetToken();
          resetUser();
          // Remove Authorization header
          config.headers.delete('Authorization');
        }
      }
    } else {
      config.headers.set("Authorization", `Bearer ${accessToken}`);
    }
  }

  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (
    error.response?.status === 401 &&
    error.response?.data?.error === "Unauthorized"
  ) {
    //place your reentry code
    const { resetToken } = getState();
    const { resetUser } = getStateUser();
    resetToken();
    resetUser();
    // window.location.href = "/";
  }

  return Promise.reject(error);
};

const setInterceptor = (axiosInstance: AxiosInstance): AxiosInstance => {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
};

setInterceptor(FETCHER);

export default FETCHER;
